module.exports = __webpack_public_path__ + "assets/img/922193.ffa7bd89.jpg";